import { render, staticRenderFns } from "./ViewRecord.vue?vue&type=template&id=64007eee&scoped=true&"
import script from "./ViewRecord.vue?vue&type=script&lang=js&"
export * from "./ViewRecord.vue?vue&type=script&lang=js&"
import style0 from "./ViewRecord.vue?vue&type=style&index=0&id=64007eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64007eee",
  null
  
)

export default component.exports